import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import CheckMark from '../../svg/icons/ic_checkmark-success_20x20.svg';
import TranslationProvider from '../../providers/TranslationProvider';
import './ResyCreditBanner.scss';

const renderEligibleTagline = (useTempCopy) => {
  if (useTempCopy) {
    return (
      <TranslationProvider translationKey="resy_credit_banner_tagline_eligible_temp_copy">
        <span>Purchases made directly at this venue currently qualify for the Resy Credit, a benefit for select American Express® Card Members.</span>
      </TranslationProvider>
    );
  }
  return (
    <TranslationProvider translationKey="resy_credit_banner_tagline_eligible">
      <span>This venue currently qualifies for the Resy Credit, a benefit for select American Express® Card Members.</span>
    </TranslationProvider>
  );
};

const ResyCreditBanner = ({ isResyCreditEligible, hideTitle, useTempCopy }) => (
  <div className={classnames('ResyCreditBanner', { 'ResyCreditBanner--noTitle': hideTitle })}>
    <div className="ResyCreditBanner__content">
      <div className="ResyCreditBanner__verbiage">
        {!hideTitle && (
          <div className="ResyCreditBanner__headline">
            {isResyCreditEligible ? (
              <>
                <TranslationProvider translationKey="resy_credit_banner_header_eligible">
                  <span>Qualifies for Resy Credit</span>
                </TranslationProvider>
                <CheckMark className="ResyCreditBanner__checkmark" />
              </>
            ) : (
              <TranslationProvider translationKey="resy_credit_banner_header_ineligible">
                <span>Resy Credit</span>
              </TranslationProvider>
            )}
          </div>
        )}
        <div className="ResyCreditBanner__tagline">
          {isResyCreditEligible ? renderEligibleTagline(useTempCopy) : (
            <TranslationProvider translationKey="resy_credit_banner_tagline_ineligible">
              <span>This venue doesn&apos;t currently qualify for the Resy Credit, a benefit for select American Express® Card Members.</span>
            </TranslationProvider>
          )}
          {' '}
          <TranslationProvider translationKey="resy_credit_banner_terms">
            <a href="https://resy.com/resycredit" target="_blank" rel="noopener noreferrer">Terms apply.</a>
          </TranslationProvider>
        </div>
      </div>
    </div>
  </div>
);

ResyCreditBanner.propTypes = {
  isResyCreditEligible: PropTypes.bool,
  hideTitle: PropTypes.bool,
  useTempCopy: PropTypes.bool,
};

ResyCreditBanner.defaultProps = {
  isResyCreditEligible: true,
  hideTitle: false,
  useTempCopy: false,
};

ResyCreditBanner.displayName = 'ResyCreditBanner';

export default ResyCreditBanner;
